import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import YouTube from 'react-youtube';

import './YoutubeVideoEmbed.scss';

class YoutubeVideoEmbed extends Component {
  static defaultProps = {
    aspectRatio: '16-by-9',
    allowFullScreen: false,
    autoPlay: false,
    showControls: true
  }

  render() {
    const baseClassName = 'pb-yt-video-embed';

    const {
      videoId,
      aspectRatio,
      allowFullScreen,
      autoPlay,
      mute,
      showControls,
      ytLockSVG,
    } = this.props;

    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--${aspectRatio}`]: aspectRatio,
    }

    const playerOptions = {
      //Ref URL: https://developers.google.com/youtube/player_parameters
      playerVars: {
        autoplay: autoPlay ? 1 : 0,
        fs: allowFullScreen ? 1 : 0,
        controls: showControls ? 1 : 0,
        mute: mute ? 1 : 0
      },
    };

    return (
      <div className={classNames(classes)}>
        <div className={`${baseClassName}__wrapper`}>
          <YouTube 
            containerClassName={`${baseClassName}__iframe-container`}
            className={`${baseClassName}__iframe`}
            videoId={videoId} 
            opts={playerOptions}
          />
         {ytLockSVG}
        </div>
      </div>
    );
  }
}

YoutubeVideoEmbed.propTypes = {
  videoId: PropTypes.string.isRequired,
  aspectRatio: PropTypes.oneOf([
    '4-by-3',
    '1-by-1',
    '16-by-9',
  ]),
  allowFullScreen: PropTypes.bool,
  autoPlay: PropTypes.bool,
  showControls: PropTypes.bool
};

export default YoutubeVideoEmbed;



// WEBPACK FOOTER //
// ./src/components/YoutubeVideoEmbed/YoutubeVideoEmbed.jsx